import React, { CSSProperties, FC } from 'react'
import AccSearchPanel from './AccSearchPanel'
import AccSearchGrid from './AccSearchGrid'
import { AccountSearchProps } from './components.type'

const style: {
  [key: string]: CSSProperties
} = {
  parent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '14px',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },

  second: {
    flex: 1,
    position: 'relative',
    marginTop: '10px',
    overflow: 'auto',
  },
}

const AccountSearch: FC<AccountSearchProps> = ({ selector, onSelect, ccy, accNo, page }) => (
  <div style={style.parent}>
    <AccSearchPanel selector={selector} ccy={ccy} accNo={accNo} page={page} />

    <div style={style.second}>
      {/* @ts-ignore */}
      <AccSearchGrid selector={selector} onSelect={onSelect} />
    </div>
  </div>
)

export default AccountSearch
